import { render, staticRenderFns } from "./travel-insurance-trip-details.vue?vue&type=template&id=c1e1ac3e&scoped=true"
import script from "./travel-insurance-trip-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-trip-details.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-trip-details.vue?vue&type=style&index=0&id=c1e1ac3e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e1ac3e",
  null
  
)

export default component.exports